import { Component, Input, SimpleChanges } from '@angular/core';
import * as dayjs from 'dayjs';
import { SearchFilter } from 'ldt-people-api';
import { Log } from 'src/app/logger.service';
import { QuickBuild, QuickBuildService, UIFilter } from 'src/app/people/quick-build.service';
import { PeopleReportService } from 'src/app/people/report-service.service';

@Component({
    selector: 'app-reports-people-count',
    template: `
    <div class="tw-bg-gray-800 tw-rounded tw-p-3 @mdx:tw-p-4 tw-w-full tw-flex">
      <div class="tw-flex tw-items-center tw-justify-between tw-gap-2 @mdx:tw-text-2xl tw-font-medium tw-text-gray-200">
      <span class="@mdx:tw-text-lg tw-text-gray-400">{{name}}</span>
        <span *ngIf="quickBuild" class="tw-text-gray-400 tw-font-thin @mdx:tw-text-lg">|</span>

        <div *ngIf="quickBuild" class="">
          {{count?.toLocaleString() || ''}}
          <span *ngIf="!count" class="loading-dots tw-flex">
            <span class="dot"></span>
            <span class="dot"></span>
            <span class="dot"></span>
          </span>
        </div>
        <mat-icon
          class="tw-text-gray-400 tw-cursor-pointer hover:tw-text-gray-100 tw-transition-colors tw-ml-auto tw-flex-shrink-0 tw-text-base @mdx:tw-text-2xl @mdx:tw-leading-6"
          [matTooltip]="tooltipText"
          [matTooltipPosition]="'above'">
          info_outline
        </mat-icon>
      </div>
    </div>
  `,
    styles: [
        `
    .loading-dots {
      display: inline-flex;
      align-items: center;
      gap: 4px;
      margin-left: 4px;
    }
    .dot {
      width: 4px;
      height: 4px;
      background-color: #9CA3AF;
      border-radius: 50%;
      animation: bounce 1.4s infinite ease-in-out;
    }
    .dot:nth-child(1) { animation-delay: -0.32s; }
    .dot:nth-child(2) { animation-delay: -0.16s; }
    @keyframes bounce {
      0%, 80%, 100% { transform: scale(0); }
      40% { transform: scale(1); }
    }
  `,
    ],
    styleUrls: ['./people-count.component.scss'],
    standalone: false
})
export class PeopleCountComponent {
  @Input() quickBuild: QuickBuild | null = null;
  @Input() countType: 'active' | 'total' = 'active';

  name: string = '';
  count: number | null = null;
  tooltipText: string = '';

  constructor(private reportService: PeopleReportService) {}

  ngOnInit(): void {
    this.name = this.countType === 'active' ? 'Active Employees' : 'All-Time Employees';
    this.tooltipText =
      this.countType === 'active'
        ? 'People we track who currently work here.'
        : 'People we track who have ever worked here.';
  }

  ngOnChanges(changes: SimpleChanges): void {
    Log.d('changes', changes);

    this.resetChartData();
    this.getChartData();
  }

  resetChartData() {
    this.count = null;
  }

  getChartData() {
    if (!this.quickBuild) return;

    const qbCopy = QuickBuildService.copyQuickBuild(this.quickBuild);

    if (this.countType === 'active') {
      const group = QuickBuildService.findFilterGroupById('moneyball', qbCopy.rootFilterGroup);
      group!.isJobsGroup = true;
      group!.jobsGroupType = 'active';
    }

    this.reportService.getCountOnly(qbCopy).subscribe((res) => {
      this.count = res.count;
    });
  }
}
